export default __webpack_public_path__ + "cf923533ea40ce294d906ec66f80e369.svg";